export default __webpack_public_path__ + "static/media/nft-list-selected.ba1c28bb.svg";